import { Component, OnInit } from '@angular/core';
import { StanjeSkladisteService } from './stanje-skladista.service';
import { moduli } from '../../config';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { PdfZaPrimkeService } from 'src/app/pdf-ovi/pdfZaPrimke.service';
import { PdfZaOtpremniceService } from 'src/app/pdf-ovi/pdfZaOtpremnice.service';
import { PdfIzdatnicaSirovinaZavrseniService } from 'src/app/pdf-ovi/pdfIzdatnicaSirovinaZavrseni.service';
import { PdfZaIzdatniceSirovinaService } from 'src/app/pdf-ovi/pdfZaIzdatniceSirovina.service'; 
import { PdfZaIzdatniceTrosakService } from 'src/app/pdf-ovi/pdfZaIzdatniceTrosak.service'; 

@Component({
  selector: 'app-stanje-skladista',
  templateUrl: './stanje-skladista.component.html',
  styleUrls: ['./stanje-skladista.component.scss'],
  providers: [StanjeSkladisteService],
})

export class StanjeSkladistaComponent implements OnInit {

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  sveZalihe: any = [];
  skladistaSirovina: any = [];
  idposlovnica: any = undefined;
  poruka: string;

  sirovine: boolean = false;
  sirovine_vr: any = 0;
  ambalaza: boolean = false;
  ambalaza_vr: any = 0;
  potrosni: boolean = false;
  potrosni_vr: any = 0;
  svaStanja: boolean = false;
  svaStanja_vr: any = 0;

  promet: any;
  currentDate = new Date();
  prvi_dan_u_godini = new Date(this.currentDate.getFullYear(), 0, 1);
  datumOd: any = moment();
  datumOd_za_slanje: any; //= moment().format('YYYY-MM-DD');
  datumDo: any = moment();
  datumDo_za_slanje: any; //= moment().format('YYYY-MM-DD');
  isLoading: boolean = true;
  dozvoli_export: boolean = false;
  disableGumb: boolean = false;
  stavke: any = [];
  idartikl: any;
  poslovnica_id: any;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(
    private service: StanjeSkladisteService,
    private pdfzaprimkeService: PdfZaPrimkeService,
    private otpremniceService: PdfZaOtpremniceService,
    private izdatniceZavrseniService: PdfIzdatnicaSirovinaZavrseniService,
    private pdfzaizdatnicesirovinaService: PdfZaIzdatniceSirovinaService,
    private pdfzaizdatnicetrosakService: PdfZaIzdatniceTrosakService
  ) {

    this.skladistaSirovina = [{ idposlovnica: undefined, po_naziv_prikaz: 'SVE' }];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().stanjeSkladista;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onRowClick(e) {
    if (e.rowType === 'data' && e.handled !== true && e.event.target.className !== 'dx-button-text' ) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  onCellPrepared(e) {
    //console.log(e);
    //console.log(e.rowType);
    //console.log(e.column.dataField);
    if (e.rowType === "data"){
      if(e.column.dataField === "za_stanje" && e.data.za_stanje > e.data.za_maximum){
        e.cellElement.style.fontWeight = "bold";
        e.cellElement.style.color = "red";
      }
      if(e.column.dataField === "za_stanje" && e.data.za_stanje < e.data.za_minimum){
        e.cellElement.style.fontWeight = "bold";
        e.cellElement.style.color = "red"
      }
    }
  }

  dohvatiSkladistaSirovina() {

    let podaciZaSlanje = {
      idfirma: localStorage.getItem('firma'),
      idkorisnik: localStorage.getItem('idsecuser'),
      //ambalaza_sirovine_potrosni_pekar: 1
    };
    //console.log(podaciZaSlanje);
    
    this.service.poslovnicaPopis(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.skladistaSirovina = [];
      this.skladistaSirovina = [{ idposlovnica: undefined, sifrainaziv: 'SVE' }];
      if (res.success == true) {
        for (let i = 0; i < res.data.length; i++) {
          this.skladistaSirovina.push({
            idposlovnica: res.data[i].idposlovnica,
            sifrainaziv: res.data[i].sifrainaziv
          });
        }
        //console.log('skladistaSirovina: ', this.skladistaSirovina);
      }
    });
  }

  odabranaGrupa1(e: any){
    //console.log(e);
    if (e.value === true) {
      this.sirovine = true;
      this.sirovine_vr = 1;
    }else{
      this.sirovine = false;
      this.sirovine_vr = 0;
    }
    this.dohvatiZalihe();
  }

  odabranaGrupa2(e: any){
    //console.log(e);
    if (e.value === true) {
      this.ambalaza = true;
      this.ambalaza_vr = 1;
    }else{
      this.ambalaza = false;
      this.ambalaza_vr = 0;
    }
    this.dohvatiZalihe();
  }

  odabranaGrupa3(e: any){
    //console.log(e);
    if (e.value === true) {
      this.potrosni = true;
      this.potrosni_vr = 1;
    }else{
      this.potrosni = false;
      this.potrosni_vr = 0;
    }
    this.dohvatiZalihe();
  }

  prikaziSvaStanja(e: any){
    //console.log(e);
    if (e.value === true) {
      this.svaStanja = true;
      this.svaStanja_vr = 1;
    }else{
      this.svaStanja = false;
      this.svaStanja_vr = 0;
    }
    this.dohvatiZalihe();
  }

  onValueChangedDatumOd(e) {
    //console.log(e);
    this.datumOd = e.value;
    this.datumOd_za_slanje = moment(e.value).format('YYYY-MM-DD');
  }
  
  onValueChangedDatumDo(e) {
    //console.log(e);
    this.datumDo = e.value;
    this.datumDo_za_slanje = moment(e.value).format('YYYY-MM-DD');
  }

  pretrazi(datumod, datumdo){
    //console.log(datumod);
    //console.log(datumdo);
    this.datumOd_za_slanje = moment(datumod).format('YYYY-MM-DD');
    this.datumDo_za_slanje = moment(datumdo).format('YYYY-MM-DD');
    this.dohvatiStavke();
  }

  onSelectionChanged(e: any): void {
    e.component.collapseAll(-1);

    this.isLoading = true;
    this.datumOd = this.prvi_dan_u_godini;
    this.datumOd_za_slanje = moment(this.prvi_dan_u_godini).format('YYYY-MM-DD');
    this.datumDo = moment();
    this.datumDo_za_slanje = moment(this.datumDo).format('YYYY-MM-DD');
    

    if (e.currentSelectedRowKeys[0]) {
      e.component.expandRow(e.currentSelectedRowKeys[0]);

      this.idartikl = e.selectedRowsData[0].ar_id;
      this.poslovnica_id = e.selectedRowsData[0].idposlovnica;

      this.dohvatiStavke();
    }
  }

  dohvatiStavke() {
    this.stavke = [];
    this.disableGumb = true;
    this.poruka = 'Učitavanje...';
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      idartikl: this.idartikl,
      idposlovnica: this.poslovnica_id,
      datumod: this.datumOd_za_slanje,
      datumdo: this.datumDo_za_slanje,
    }
    //console.log(podaciZaSlanje);
    this.service.dokumentiZaArtikl(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      this.disableGumb = false;
      if (res.success == true) {
        this.stavke = res.data;
      }else{

      }
      if (this.stavke.length > 0) {
        this.poruka = 'Učitavanje...';
      } else {
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  promjenaSkladista(e){
    //console.log(e);
    //console.log(e.value);
    this.idposlovnica = e.value;
    this.dohvatiZalihe();
  }
  
  dohvatiZalihe(){
    this.dozvoli_export = false;
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      idposlovnica: this.idposlovnica,
      sirovine: this.sirovine_vr,
      ambalaza: this.ambalaza_vr,
      potrosni: this.potrosni_vr,
      svaStanja: this.svaStanja_vr,
    }
    //console.log(podaciZaSlanje);
    this.sveZalihe = [];
    this.poruka = 'Učitavanje...';
    this.service.stanjeSkladista(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.sveZalihe = res.data;
      } else {
        
      }
      if (this.sveZalihe.length > 0) {
        this.dozvoli_export = true;
        this.poruka = 'Učitavanje...';
      } else {
        this.dozvoli_export = false;
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  calculateAktivan(rowData: any) {
    return rowData.ar_aktivan === 1 ? 'DA' : 'NE';
  }

  calculateSkladiste(rowData: any) {
    const sifra = rowData?.po_sifra ?? '';
    const naziv = rowData?.po_naziv ?? '';
    return `${sifra} ${naziv}`.trim();
  }

  ispisiPDF(e){
    //console.log(e);
    //console.log(e.data);
    if (e.data.dv_sifra == 'PRISKL') {
      //console.log('SKLADISNA PRIMKA');
      this.pdfzaprimkeService.pdfPrimka(e);
    }
    if (e.data.dv_sifra == 'OTPREM') {
      //console.log('OTPREMNICA');
      this.otpremniceService.pdfOtpremnica(e);
    }
    if (e.data.dv_sifra == 'MSKLAD') {
      //console.log('MEĐUSKLADIŠNICA - Izlaz');
    }
    if (e.data.dv_sifra == 'IZDSIR') {
      //console.log('Izdatnica sirovina');
      this.pdfzaizdatnicesirovinaService.izdatnicaSirovinaPDF(e);
    }
    if (e.data.dv_sifra == 'IZDTRO') {
      //console.log('Izdatnica trošak');
      this.pdfzaizdatnicetrosakService.izdatnicaTrosakPDF(e);
    }
  }

  ngOnInit(): void {
    this.dohvatiSkladistaSirovina();
    this.dohvatiZalihe();
  }

}
